import React from 'react'

import { RiDeleteBinLine } from 'react-icons/ri'
import { LuPencil } from 'react-icons/lu'

import styled from 'styled-components'

const CharacterReferenceDetails = ({
  crName,
  crEmail,
  crPhone,
  id,
  withActionButtons = true,
  handleDelete,
  handleEdit,
}) => {
  return (
    <StyledCharacterRefDetails>
      <div className="character-ref__header">
        <p className="character-ref__name">{crName}</p>
        {withActionButtons && (
          <div className="character-ref__actions">
            <LuPencil
              className="character-ref__icon"
              onClick={() => handleEdit(id)}
            />
            <RiDeleteBinLine
              className="character-ref__icon"
              onClick={() => handleDelete(id)}
            />
          </div>
        )}
      </div>
      <div className="character-ref__details">
        <p className="character-ref__paragraph">{crEmail}</p>
        <p className="character-ref__paragraph">{crPhone}</p>
      </div>
    </StyledCharacterRefDetails>
  )
}

const StyledCharacterRefDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  .character-ref__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 500;
  }

  .character-ref__name {
    margin: 0;
  }

  .character-ref__actions {
    display: flex;
    gap: 1rem;
    cursor: pointer;
  }

  .character-ref__icon {
    font-size: 1.2rem;
  }

  .character-ref__details {
    font-weight: 300;
  }

  .character-ref__paragraph {
    margin: 0;
  }
`

export default CharacterReferenceDetails
